import { PictureContainer, Image, Overlay } from './styled'

function RoundPicture({ className, picture, src, alt, fallback, fit = 'cover', sizes = '160px', overlay, ...props }) {
  return (
    <PictureContainer className={className} {...props}>
      <Image picture={picture} src={fallback || src} alt={alt} fit={fit} sizes={sizes} />
      {overlay && <Overlay>{overlay}</Overlay>}
    </PictureContainer>
  )
}

export default RoundPicture
